import React, { createContext, useContext } from 'react';
import { Thread } from '../types/thread';
import { useThreads as useThreadsHook } from '../hooks/useThreads';

interface ThreadsContextType {
  threads: Thread[];
  loading: boolean;
  error: string | null;
  totalUnreadCount: number;
  refreshThreads: () => Promise<void>;
  markThreadRead: (threadId: string) => void;
}

const ThreadsContext = createContext<ThreadsContextType | undefined>(undefined);

export const useThreadsContext = () => {
  const context = useContext(ThreadsContext);
  if (!context) {
    throw new Error('useThreadsContext must be used within a ThreadsProvider');
  }
  return context;
};

interface ThreadsProviderProps {
  children: React.ReactNode;
}

export const ThreadsProvider: React.FC<ThreadsProviderProps> = ({ children }) => {
  const threadsData = useThreadsHook();

  return <ThreadsContext.Provider value={threadsData}>{children}</ThreadsContext.Provider>;
};
